import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SpringSystem } from 'rebound';

export default class CustomScrollbars extends Component {
	componentDidMount () {
		this.springSystem = new SpringSystem();
		this.spring = this.springSystem.createSpring();
		this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
	}

	componentWillUnmount () {
		this.springSystem.deregisterSpring(this.spring);
		this.springSystem.removeAllListeners();
		this.springSystem = undefined;
		this.spring.destroy();
		this.spring = undefined;
	}

	handleSpringUpdate = spring => {
		const val = spring.getCurrentValue();
		this.scrollbars.scrollTop(val);
	}

	render () {
		return (
			<Scrollbars {...this.props} ref={c => this.scrollbars = c} />
		);
	}
}


// WEBPACK FOOTER //
// ./components/CustomScrollbars.js